import { BaseContract } from './common/base.contract';
import { Contract, JsonRpcProvider } from 'ethers';
import CdkDiamondsAbi from '../abi/CdkDiamonds.json';

export type CdkTeam = {
    operatingTeam: number;
    advisor: number;
}

export type Reserves = {
    reserve: number;
    additionalReserves: number;
}

export type CdkTokenAllocationLayout = {
    tokenSale: number;
    cdkTeam: CdkTeam;
    development: number;
    ecosystem: number;
    liquidity: number;
    reserves: Reserves;
}

export class CdkDiamonds extends BaseContract {
    constructor(address: string, provider: JsonRpcProvider) {
        super(new Contract(address, CdkDiamondsAbi.abi, provider));
    }

    // Méthodes de lecture
    getFallbackAddress = async (): Promise<string> => {
        return await this.contract.getFallbackAddress();
    }

    nomineeOwner = async (): Promise<string> => {
        return await this.contract.nomineeOwner();
    }

    owner = async (): Promise<string> => {
        return await this.contract.owner();
    }

    supportsInterface = async (interfaceId: string): Promise<boolean> => {
        return await this.contract.supportsInterface(interfaceId);
    }

    // Méthodes d'écriture
    setFallbackAddress = async (fallbackAddress: string) => {
        const contractWithSigner = await this._getSignedContract();
        const tx = await contractWithSigner.setFallbackAddress(fallbackAddress);
        await tx.wait();
    }

    transferOwnership = async (account: string) => {
        const contractWithSigner = await this._getSignedContract();
        const tx = await contractWithSigner.transferOwnership(account);
        await tx.wait();
    }
} 
